import {
  ArrowBack as ArrowBackIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import { Box, Typography, IconButton, Breadcrumbs, Link } from "@mui/material";
import React from "react";
import { useParams, useNavigate } from "react-router";

import ActivityMetricChart from "../components/features/patient/detail/ActivityMetricChart";
import DashboardLayout from "../components/layouts/DashboardLayout";
import { MetricValuesAggregationRequestDtoMetricCodeEnum } from "../libs/cellera-sdk";

const ACTIVITY_METRICS = [
  {
    metricCode: MetricValuesAggregationRequestDtoMetricCodeEnum.StepCounts,
    title: "Steps",
  },
  {
    metricCode: MetricValuesAggregationRequestDtoMetricCodeEnum.Distance,
    title: "Distance",
  },
  {
    metricCode: MetricValuesAggregationRequestDtoMetricCodeEnum.ActiveCalories,
    title: "Active Calories",
  },
  {
    metricCode: MetricValuesAggregationRequestDtoMetricCodeEnum.Workouts,
    title: "Workouts",
  },
  {
    metricCode: MetricValuesAggregationRequestDtoMetricCodeEnum.FloorClimbed,
    title: "Floors Climbed",
  },
];

const ActivityPage: React.FC = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const navigate = useNavigate();

  if (!patientId)
    return (
      <Box sx={{ p: 2 }}>
        <Typography>No patient found</Typography>
      </Box>
    );

  return (
    <DashboardLayout title="Activity">
      <Box sx={{ p: 2 }}>
        {/* Breadcrumbs */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Breadcrumbs>
            <Link color="inherit" href="/dashboard">
              Dashboard
            </Link>
            <Link color="inherit" href="/patients">
              Patient Details
            </Link>
            <Typography color="text.primary">Activity</Typography>
          </Breadcrumbs>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton
              onClick={() => navigate(-1)}
              size="small"
              sx={{ color: "text.secondary" }}
            >
              <ArrowBackIcon />
            </IconButton>
            <IconButton
              onClick={() => window.location.reload()}
              size="small"
              sx={{ color: "text.secondary" }}
            >
              <RefreshIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Charts grid */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 351px)",
              md: "repeat(3, 351px)",
            },
            gap: 2,
            justifyContent: "center",
          }}
        >
          {ACTIVITY_METRICS.map((metric) => (
            <ActivityMetricChart
              key={metric.metricCode}
              patientId={patientId}
              metricCode={metric.metricCode}
              title={metric.title}
            />
          ))}
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default ActivityPage;
